var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHyperlinkSubMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3593_196201)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.24139 0H16.9655V6.62067H1.24139C0.555797 6.62067 0 6.06492 0 5.37933V1.24139C0 0.555797 0.555797 0 1.24139 0V0Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1725 0H17.7932V6.62067H23.1725C23.6291 6.61931 23.9988 6.24956 24.0001 5.79309V0.827578C23.9988 0.371109 23.629 0.00135937 23.1725 0V0ZM22.5725 3.33516L21.4967 4.94897C21.3155 5.21873 21.0116 5.38022 20.6866 5.37937C20.3616 5.37853 20.0585 5.2155 19.8787 4.9448L18.807 3.33516C18.583 3.00502 18.56 2.57794 18.7474 2.22572C18.9349 1.87345 19.3018 1.65384 19.7008 1.65516H21.6788C22.0778 1.65384 22.4448 1.87345 22.6322 2.22572C22.8195 2.57798 22.7966 3.00502 22.5725 3.33516Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9022 2.61491C21.9206 2.65077 21.9305 2.69043 21.9311 2.73079C21.9308 2.78122 21.9149 2.83035 21.8856 2.87146L20.8097 4.4894C20.7827 4.52891 20.7376 4.55221 20.6897 4.55146C20.6408 4.55216 20.5952 4.52699 20.5697 4.48527L19.4939 2.87146C19.4393 2.79627 19.4329 2.69647 19.4773 2.61491C19.5203 2.53166 19.6071 2.48029 19.7008 2.48249H21.6787C21.7724 2.48029 21.8591 2.53171 21.9022 2.61491Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.827578 8.27539H16.5517C17.0088 8.27539 17.3793 8.64589 17.3793 9.10297V11.5858C17.3793 12.0428 17.0088 12.4133 16.5517 12.4133H0.827578C0.3705 12.4133 0 12.0428 0 11.5857V9.10292C0 8.64589 0.3705 8.27539 0.827578 8.27539Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.827578 14.0684H16.5517C17.0088 14.0684 17.3793 14.4389 17.3793 14.8959V17.3787C17.3793 17.8358 17.0088 18.2063 16.5517 18.2063H0.827578C0.3705 18.2063 0 17.8358 0 17.3787V14.8959C0 14.4389 0.3705 14.0684 0.827578 14.0684Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.827578 19.8613H16.5517C17.0088 19.8613 17.3793 20.2319 17.3793 20.6889V23.1717C17.3793 23.6288 17.0088 23.9993 16.5517 23.9993H0.827578C0.3705 23.9993 0 23.6287 0 23.1717V20.6889C0 20.2319 0.3705 19.8613 0.827578 19.8613Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3593_196201"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHyperlinkSubMenu);
export default __webpack_public_path__ + "static/media/hyperlink-sub-menu.8c85f266ef757855bcbf72aedcdda968.svg";
export { ForwardRef as ReactComponent };